import { Box, Tooltip } from "@mui/material";
import { Phone } from "@mui/icons-material";
import { keyframes } from "@mui/system";
import { useActiveCallForPhone } from "../../sockets/useActiveCallForPhone";
import { LiveCall } from "../../store/store.types";

const iconPulseAnimation = keyframes`
    0% {
        box-shadow: 0 0 0 0 rgba(223, 100, 73, 0.6);
    }
    70% {
        box-shadow: 0 0 0 6px rgba(223, 100, 73, 0);
    }
    100% {
        box-shadow: 0 0 0 0 rgba(223, 100, 73, 0);
    }
`;

const buildTooltipText = (activeCall: LiveCall) => {
    const firstName = activeCall.agentUser?.firstName ?? null;
    const lastName = activeCall.agentUser?.lastName ?? null;
    const extension = activeCall.agentExtension ?? null;
    if (firstName && lastName && extension) {
        const text = `Em chamada por ${firstName} ${lastName} (ext ${extension})`;
        return text;
    }
    if (firstName && lastName) {
        const text = `Em chamada por ${firstName} ${lastName}`;
        return text;
    }
    if (extension) {
        const text = `Em chamada (ext ${extension})`;
        return text;
    }
    return "Em chamada";
};

type LiveCallCellRow = {
    phone?: string | null;
};

type LiveCallCellProps = {
    row: LiveCallCellRow;
};

export const LiveCallCell = ({ row }: LiveCallCellProps) => {
    const activeCall = useActiveCallForPhone(row.phone);

    if (!activeCall) {
        return null;
    }

    const tooltipText = buildTooltipText(activeCall);

    return (
        <Tooltip title={tooltipText} placement="top" arrow>
            <Box
                component="span"
                sx={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: 28,
                    height: 28,
                    borderRadius: "50%",
                    color: "#df6449",
                    animation: `${iconPulseAnimation} 1.5s infinite`,
                    cursor: "help",
                }}
            >
                <Phone sx={{ fontSize: 20 }} />
            </Box>
        </Tooltip>
    );
};
